<template>
    <v-dialog
        content-class="border-radius-3"
        v-model="dialog"
        persistent
        max-width="610"
        :retain-focus="false"
        overlay-color="primary"
        overlay-opacity="0.75"
    >
        <v-card v-resize="onResize">
            <v-card-title class="pt-8 px-10">
                <v-row justify="center" justify-md="space-between">
                    <v-btn
                        color="#302656"
                        class="no-uppercase text-body-1 white--text my-2 my-md-0 mx-sm-2 mx-md-0"
                        width="250"
                        height="60"
                        elevation="4"
                        @click="closeModal"
                    >
                        <v-icon class="mr-2">mdi-undo-variant</v-icon>
                        {{ backText }}
                    </v-btn>
                    <v-card
                        width="250"
                        height="60"
                        elevation="4"
                        class="py-2 color-text text-body-1 my-2 my-md-0 mx-sm-2 mx-md-0"
                    >
                        <v-row align="center" justify="center">
                            <v-img src="/img/user/beecoin-3.svg" height="40" max-width="40" class="mr-2"></v-img>
                            {{ $t('profile.you_have') }}
                            <span class="font-weight-bold mx-1">
                                {{ userData.coins }} Beecoins
                            </span>
                        </v-row>
                    </v-card>
                </v-row>
            </v-card-title>
            <v-card-text class="py-0">
                <v-card elevation="0" v-if="buyData.value">
                    <v-row justify="center" class="mx-0 px-0 pb-0" v-if="buyData.isAvatar">
                        <v-img
                            :src="`https://assets.beereaders.com/avatar/${buyData.value.name}/${buyData.value.value}`"
                            :height="imgSize"
                            :max-width="imgSize"
                            class="ma-2 skin-img"
                        />
                    </v-row>
                    <v-row justify="center" class="mx-0 px-0 py-6" v-if="buyData.isSkin">
                        <v-img
                            :src="`https://assets.beereaders.com/skins/${getThumbnail(buyData.value)}`"
                            :height="imgSize/1.5"
                            :max-width="imgSize/1.5"
                            class="ma-2 skin-img"
                        />
                    </v-row>
                    <v-overlay absolute :value="true" opacity="0">
                        <v-img
                            src="/img/user/bg-price.svg"
                            :max-height="priceIconSize*1.1"
                            :max-width="priceIconSize"
                            class="price-avatar"
                            v-if="buyData.isAvatar"
                        >
                            <v-row class="text-price color-price font-weight-bold" justify="center">
                                {{ buyData.value.avatarPack.price }}
                            </v-row>
                            <v-row class="color-price coins text-beecoins" justify="center">
                                Beecoins
                            </v-row>
                        </v-img>
                        <v-img
                            src="/img/user/bg-price.svg"
                            :max-height="priceIconSize*1.1"
                            :max-width="priceIconSize"
                            class="price-skin"
                            v-if="buyData.isSkin"
                        >
                            <v-row class="text-price color-price font-weight-bold" justify="center">
                                {{ buyData.value.price }}
                            </v-row>
                            <v-row class="color-price coins text-beecoins" justify="center">
                                Beecoins
                            </v-row>
                        </v-img>
                    </v-overlay>
                </v-card>
                
                <span class="color-text text-h3">
                    {{ elementText }}
                </span>
                <p class="px-12 mt-8 mb-0 color-text text-body-1 font-weight-bold">
                    {{ descriptionText }}
                </p>
            </v-card-text>
            <v-card-actions class="d-flex justify-center py-12">
                <v-btn
                    color="secondary"
                    class="no-uppercase text-h6"
                    width="300"
                    x-large
                    rounded
                    @click="toBuy"
                    :loading="btnLoading"
                    :disabled="userData.coins<price"
                >
                    {{ buyText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import GamificationService from '../../services/gamification'
import PurchaseService from '../../services/purchase'

const defaultData = {
    isAvatar: false,
    isSkin: false,
    value: null
}

export default {
    props: {
        buyData: { type: Object, default: defaultData },
        dialog: { type: Boolean, default: false }
    },
    data() {
        return {
            btnLoading: false,
            imgSize: 300,
            reload: 0,
            selectedSkin: {},
            priceIconSize: 300,
            windowSize: {
                x: 0,
                y: 0
            }
        }
    },
    mounted() {
        this.onResize()
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            userData: (state) => state.userData
        }),
        backText() {
            return this.buyData.isAvatar ? this.$t('profile.back_to_avatars') : this.$t('profile.back_to_skins')
        },
        elementText() {
            return this.buyData.isAvatar ? this.$t('profile.special_avatar') : this.$t('profile.special_skin')
        },
        descriptionText() {
            return this.buyData.isAvatar ? this.$t('profile.purchase_avatar_desc') : this.$t('profile.purchase_skin_desc')
        },
        buyText() {
            return this.buyData.isAvatar ? this.$t('profile.buy_this_avatar') : this.$t('profile.buy_this_skin')
        },
        price() {
            if (this.buyData.isAvatar) {
                return this.buyData.value.avatarPack.price
            }
            return this.buyData.isSkin ? this.buyData.value.price : 0
        }
    },
    methods: {
        ...mapActions('userData', [
            'setGamification',
        ]),
        closeModal () {
            this.$emit('close')
        },
        async getGamification () {
            GamificationService.getUserGameStatsByUser(
                this.user.id
            )
            .then((response) => {
                if (response.content.id) {
                    this.setGamification(response.content)
                }
            })
            .catch((error) => console.error(error))
        },
        getThumbnail(skin) {
            const img = skin.resources.find((res) => res.resourceUrl.includes('thumbnail'))
            return img.resourceUrl
        },
        onResize () {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
            if (this.windowSize.y < 670) {
                this.imgSize = 80
                this.priceIconSize = 60
                return
            }
            if (this.windowSize.y < 725) {
                this.imgSize = 130
                this.priceIconSize = 60
                return
            }
            if (this.windowSize.y < 835) {
                this.imgSize = 180
                this.priceIconSize = 60
                return
            }
            this.imgSize = 280
            this.priceIconSize = 280
        },
        async toBuy () {
            this.btnLoading = true
            if (this.buyData.isAvatar) {
                await PurchaseService.createPurchaseAvatarPack(
                    this.user.id,
                    this.buyData.value.avatarPack.id
                )
                .catch((error) => console.error(error))
                this.btnLoading = false
            } else {
                await PurchaseService.createPurchaseSkin(
                    this.user.id,
                    this.buyData.value.id
                )
                .catch((error) => console.error(error))
            }
            await this.getGamification()
            this.btnLoading = false
            this.closeModal()
        }
    }
}
</script>

<style scoped>
.color-primary {
    color: #514773;
}
.color-text {
    color: #4A3216;
}
.color-price {
    color: #DF820D;
}
.coins {
    margin-top: -5px;
}
.price-avatar {
    margin-top: 180px;
}
.price-skin {
    margin-top: 60px;
}
.text-price {
    font-size: .75rem;
    margin-top: 15px;
}
.text-beecoins {
    font-size: .65rem;
    margin-top: -10px;
}

@media (min-height: 500px) {
    .price-avatar {
        margin-top: 50px;
    }
    .price-skin {
        margin-top: 60px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 10px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 670px) {
    .price-avatar {
        margin-top: 80px;
    }
    .price-skin {
        margin-top: 90px;
    }
    .text-price {
        font-size: .75rem;
        margin-top: 10px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -5px;
    }
}
@media (min-height: 725px) {
    .price-avatar {
        margin-top: 130px;
    }
    .price-skin {
        margin-top: 120px;
    }
    .text-price {
        font-size: .9rem;
        margin-top: 15px;
    }
    .text-beecoins {
        font-size: .65rem;
        margin-top: -8px;
    }
}
@media (min-height: 835px) {
    .price-avatar {
        margin-top: 170px;
    }
    .price-skin {
        margin-top: 150px;
    }
    .text-price {
        font-size: 1.25rem;
        margin-top: 30px;
    }
    .text-beecoins {
        font-size: 1rem;
        margin-top: 0px;
    }
}

.no-uppercase {
     text-transform: none;
}
.skin-img {
    display: block;
    width: 100%;
    border-radius: 20px;
}
</style>